  $(document).ready(function() {
    $(function() {
      var observer = new MutationObserver(function(e) {
        if(e[0].target.innerText == '0') {
          $('.js-go-cart-counter').hide();
        } else {
          $('.js-go-cart-counter').show();
        }
      });
      observer.observe($('.js-go-cart-counter')[0], {
        characterData: true,
        childList: true
      });
    });
    
    $('.search-modal-link').click(function(){
      $('.search-field ').focus();
    });
    
    document.getElementById('modal-search-input').addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // Prevents accidental double-submission
        document.getElementById('modal-search-form').submit();
      }
    });

    var retriesMiniCart = 0;
    var proCheckMiniCart = setInterval(function () {
      if(retriesMiniCart == 100) {
        console.log("Stopping Retry, Minicart");
        clearInterval(proCheckMiniCart);
      }
      if ($(".csapp-discount-list").length > 0 && $(".yotpo-notif-sidecart").length == 0) {
        $('.csapp_discount_total_wrapper').parent().after(`
          <div class="yotpo-notif-sidecart clearfix margin-x-sm" style="padding: 10px; border: 1px solid #E5E4E2; margin-bottom: 10px; display: flex;">
            <!--<span style="font-size: 30px; float: left; height: 65px; margin-right: 15px; line-height: 28px;">&#9432;</span>-->
            <div style="float: left; flex-grow: 1;"><img style="margin-right: 15px; height: 25px; max-width: fit-content;" src="https://cdn.shopify.com/s/files/1/0658/6335/2559/files/info_icon_dbb3607d-c765-4ed5-ae43-75bdb6829eb3_256x256.png" /></div>
            <p style="">Applying your Tala Pro Discount may slightly delay reward redemption. Please wait up to 1 minute and refresh to redeem both at checkout.</p>
          </div>
        `);
        // $('.csapp-price-saving').hide();
        clearInterval(proCheckMiniCart);
      }
      retriesMiniCart++;
    }, 200); 

    $('.privacy-notice-link').append("<span class='screen-reader-text'> Details</span>");
    
    $(function() {
      var observer2 = new MutationObserver(function(e) {
        var sign = $('.shop_curreny_symbol').text();
        var money_sign = sign.substring(0, 1);
      
        var go_sub_total = 0;
        $('.base_comprice').each(function(e){
          var go_price = parseInt($('.base_price').eq(e).text());
          var comp_price = parseInt($(this).text());
          var go_q = parseInt($('.js-go-cart-quantity').eq(e).val());
          var price_total = go_price * go_q;
          var comp_price_total = comp_price * go_q;

          $('.go-cart-item__price').eq(e).html("<span class='comp_price_total'>"+
                                               "<s>"+money_sign+""+(comp_price_total/Math.pow(10, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')+"</s> "
                                               +money_sign+""+(price_total/Math.pow(10, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                                               +"</span>");
          
          go_sub_total = go_sub_total + comp_price_total;
        });
      
        if($(".updated_go").length == 0) {
          $('.js-go-cart-drawer-subtotal-separator').before("<s class='updated_go' style='font-size: 14px; line-height: 24px;'>"+money_sign+""+(go_sub_total/Math.pow(10, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')+"</s>");
        } else {
          $('.updated_go').text(money_sign+""+(go_sub_total/Math.pow(10, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        }
        
        var sub_total = 0;
        var sub_total_sign = '';
        var line_has_disc = false;
        var computed_cart_total = 0;
        $('.js-cart-line-price').each(function(){
          const raw_line_sub = $(this).text();
          const line_sub = parseInt(raw_line_sub.replace("£", "").replace("$", "").replace("€", "").replace(".", "").replace(",", ""));
          computed_cart_total = computed_cart_total + line_sub;

          const qty = $(this).parent().parent().parent().find('.js-cart-quantity').val();
          var disc = parseInt($(this).parent().parent().parent().find('.discount_line').text());

          if(isNaN(disc)) {
            // disc = 0;
            const disc_check = $(this).parent().parent().parent().find('.js-cart-line-original-price').text();
            if(disc_check != '') {
              disc = parseInt($(this).parent().parent().parent().find('.price_line').text());
              if(disc == 0) {
                disc = parseInt($(this).parent().parent().parent().find('.original_price_line').text());
              }
              // disc_raw = $(this).parent().parent().parent().find('.js-cart-line-original-price').text();
              // disc = parseInt(disc_raw.replace("£", "").replace("$", "").replace("€", "").replace(",", "").replace(".", ""));
            } else {
              disc = 0;
            }
          } else {
            line_has_disc = true;
          }
          const computed_disc = qty * disc;
          sub_total = sub_total + computed_disc;

          const updated_disc = money_sign+''+(computed_disc/Math.pow(10, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          $(this).parent().parent().parent().find('s').text(updated_disc);
        });
        const sub_total_text = money_sign+''+(sub_total/Math.pow(10, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

        $('.cart_subtotal').find('s').text(sub_total_text);
        
        const cart_total_current_raw = $('.js-cart-subtotal').find('span').text();
        const cart_total_current_check = parseInt(cart_total_current_raw.replace("£", "").replace("$", "").replace("€", "").replace(".", "").replace(",", ""));
        if(cart_total_current_check != computed_cart_total) {
          const computed_cart_total_final = money_sign+''+(computed_cart_total/Math.pow(10, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          $('.js-cart-subtotal').find('span').text(computed_cart_total_final);
        }
        if(line_has_disc) {
          $('.product-card-discount').show();
          $('.js-cart-subtotal').addClass('price-sale');
        } else {
          $('.product-card-discount').hide();
          $('.js-cart-subtotal').removeClass('price-sale');
        }
      });
      observer2.observe($('.js-go-cart-drawer-subtotal')[0], {
        characterData: true,
        childList: true
      });
    });

    $(function() {
      var observer3 = new MutationObserver(function(e) {
        $('.go-cart-drawer__content .go-cart-item__title').each(function(i){
          var cart_item = $(this).text().trim();
          
          $('.prodnotice').each(function(j){
            if(cart_item == $(this).text().trim()) {
              $('.go-cart-drawer__content .go-cart-item__price').eq(i).prepend('<div style="font-size: 10px; margin-bottom: 6px; line-height: 12px;">Preorder item: estimated arrival in 4-6 weeks.</div>');
              // $('<div style="font-size: 11px; margin-top: 10px; line-height: 12px;">Preorder item: estimated arrival in 4-6 weeks.</div>').prependTo('.go-cart-drawer__content .go-cart-item__price:eq('+i+')');
            }
          });
        });
      });
      observer3.observe($('.go-cart-drawer__content')[0], {
        characterData: true,
        childList: true
      });
    });
  });